import { dashboardSlice } from "./dashboardSlice";
import * as actions from "./dashboardActions";
import * as selectors from "./dashboardSelectors";

export { actions };
export { selectors };
export default dashboardSlice.reducer;
